import React from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_VerifyEmailAddress.scss'

const VerifyEmailAddress = ({
  verifiedEmailAddress,
  adviserName,
  viewAdviser
}) => (
  <div className={styles['wrapper']}>
    <h1 className={styles['heading']}>Rating successfully submitted</h1>
    <p>The rating for <a href={''} onClick={(e) => { e.preventDefault(); viewAdviser() }}>
      <strong>{adviserName}</strong>
    </a> has been confirmed.
      </p>
    <p>
      <a href={'https://www.allangray.co.za'}>Allan Gray home page</a><br />
      <a href={'https://www.allangray.co.za/find-an-ifa'}>Find an IFA home page</a>
    </p>
  </div>
  )

VerifyEmailAddress.propTypes = {
  verifiedEmailAddress: PropTypes.string.isRequired,
  adviserName: PropTypes.string.isRequired,
  viewAdviser: PropTypes.func.isRequired
}

export default  (VerifyEmailAddress)
